import React from "react";
import ComingSoon from "../../../components/ComingSoon";

export default function Payroll() {
  return <ComingSoon title="Payroll Management" />;
}
